export default __webpack_public_path__ + "static/media/anti-slip_anthracite.bb8077f7.webp";